import { useState } from "react";

import type { AssistantStep } from "@/lib/types";

import { ActivityTimeline } from "./ActivityTimeline";

interface AssistantStepsProps {
  steps: AssistantStep[];
}

export function AssistantSteps({ steps }: AssistantStepsProps) {
  const [expanded, setExpanded] = useState(false);

  const totalTools = steps.reduce((sum, s) => sum + s.tools.length, 0);

  const summary = [
    `${steps.length} step${steps.length !== 1 ? "s" : ""}`,
    totalTools > 0 ? `${totalTools} tool call${totalTools !== 1 ? "s" : ""}` : null,
  ]
    .filter(Boolean)
    .join(" \u00b7 ");

  return (
    <div className="border-cyber-border/50 bg-cyber-bg/30 mb-2 rounded border text-xs">
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
        className="text-cyber-muted hover:text-cyber-text flex w-full items-center gap-2 px-3 py-1.5 text-left transition-colors"
      >
        <span className="text-[10px]">{expanded ? "\u25BC" : "\u25B6"}</span>
        <span>{summary}</span>
      </button>

      {expanded && (
        <div className="border-cyber-border/30 space-y-3 border-t px-3 py-2">
          <ActivityTimeline steps={steps} />
        </div>
      )}
    </div>
  );
}
